import styled from "styled-components";

export const Wrap = styled.div`
  padding: 0 16px;
`;

export const Img = styled.img`
  width: 100%;
  height: auto;
  border-radius: 16px;
  display: block;
  vertical-align: top;
`;
